import { DEFAULT_CITY } from "../../constants/app-constants";

/**
   * @returns {object} params code,name,id
   */
export const getCity = ({cityInfo = {}}) => {
    return ({...cityInfo, code: (cityInfo || {}).code || DEFAULT_CITY.AU.code});
};
